<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de opção de entrada">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'painel-senha-opcao-entrada-create' })"
                    color="primary"
                    authorize="store-painel-senha-opcao-entrada"
                >
                    Cadastrar opção de entrada
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/painel-senha/opcao-entrada/List'

export default {
    components: { List },
}
</script>